import { axiosRequest } from '@/lib/axios/axios.ts'
import { storeToRefs } from 'pinia'
import { useCommonStore } from '@/stores/common.ts'
import { useEditorStore } from '@/stores/editor.ts'
import { deletePrefix } from '@/views/editor/composable/useNoteUtils'
import { createBlockEvent } from '@/views/editor/composable/useBlockCreate'

export const getFileExtension = (fileName: string): string | undefined => {
	const splitName = fileName.split('.')
	return splitName.length > 1 ? splitName.pop() : '확장자 없음'
}
export const addFileBlock = (file: any) => {
	const { lang } = storeToRefs(useCommonStore())
	const fileContainer = document.createElement('div')
	fileContainer.setAttribute('contenteditable', 'false')
	fileContainer.classList.add('file--container')
	fileContainer.dataset.testid = 'file-attachment-container'

	const fileTitle = document.createElement('div')
	fileTitle.classList.add('file--title')
	fileTitle.dataset.testid = 'file-attachment-title'
	fileTitle.innerHTML = `<div><span>${lang.value['file']['attachments']}</span><span class="strong file--length" data-testid="file-attachment-count">${file.length}</span><span>${lang.value['file']['item']}</span></div><div><button class="btn btn--none" data-testid="file-attachment-btn-delete-all">${lang.value['button']['allDelete']}</button></div>`

	fileContainer.appendChild(fileTitle)

	const fileContent = document.createElement('div')
	fileContent.classList.add('file--content')
	fileContent.dataset.testid = 'file-attachment-content'
	file.forEach((item: any) => {
		const fileItem = document.createElement('div')
		fileItem.classList.add('file--content__list')
		fileItem.dataset.testid = 'file-attachment-item'
		fileItem.dataset.originName = item.originName
		fileItem.dataset.file = item.uuidFileName

		const fileItemContainer = document.createElement('div')
		fileItemContainer.dataset.testid = `file-attachment-download`

		const fileItemIcon = document.createElement('i')
		fileItemIcon.classList.add(`ico`, `ico--file__${getFileExtension(item.originName)}`)
		fileItemIcon.dataset.testid = `file-attachment-icon`

		fileItemContainer.appendChild(fileItemIcon)

		const fileItemSpan = document.createElement('span')
		fileItemSpan.dataset.testid = `file-attachment-name`
		fileItemSpan.innerHTML = item.originName

		fileItemContainer.appendChild(fileItemSpan)

		fileItem.appendChild(fileItemContainer)

		const fileItemDeleteButton = document.createElement('button')
		fileItemDeleteButton.classList.add('btn', 'btn--none')
		fileItemDeleteButton.dataset.testid = `file-attachment-btn-delete`
		fileItemDeleteButton.innerHTML = `<i class="ico ico--close"></i>`

		fileItem.appendChild(fileItemDeleteButton)

		fileContent.appendChild(fileItem)
	})

	fileContainer.appendChild(fileContent)

	return fileContainer
}

export const downloadFile = async (e: any) => {
	const { isWrite, noteUid, noteType } = storeToRefs(useEditorStore())
	if (!isWrite.value) return
	const { target } = e
	const fileList = target.closest('.file--content__list')
	const uuidFileName = fileList.dataset.file
	const name = fileList.dataset.originName
	const type = noteType.value === 'Project' ? 'project' : 'template'
	const res: any = await axiosRequest(`/v1/${type}/download/${noteUid.value}/${uuidFileName}`, {}, {}, 'GET', {
		params: { filename: name },
		responseType: 'blob',
	})

	// 다운로드 트리거 (브라우저에서 다운로드 가능하도록)
	const url = window.URL.createObjectURL(res)
	const link = document.createElement('a')

	link.href = url
	link.download = name
	link.target = '_blank'
	link.click()

	// 메모리 해제
	window.URL.revokeObjectURL(url)
}

export const deleteFile = async (e: any) => {
	const { socket } = storeToRefs(useCommonStore())
	const { isWrite, noteUid, noteType } = storeToRefs(useEditorStore())
	if (!isWrite.value) return
	const { target } = e
	const fileList = target.closest('.file--content__list')

	const fileContent = fileList.closest('.file--content')
	const fileContainer = fileList.closest('.file--container')
	const fileLength = fileContainer.querySelector('.file--length')
	fileList.remove()
	const fileListArray = fileContent.querySelectorAll('.file--content__list')
	const fileListLength = fileListArray.length
	const fileUid = deletePrefix(fileContent.closest('.editor--block').id)

	const fileData: any = []
	fileListArray.forEach((item: any) => {
		fileData.push(item.dataset.file)
	})
	if (noteType.value === 'Project') {
		await socket.value.modifyNoteBlock(noteUid.value, fileUid, fileData.join(','), 'file')
	}
	if (fileListLength < 1) {
		if (noteType.value === 'Project') {
			socket.value.deleteNoteBlock(noteUid.value, fileUid)
		}
		fileContent.closest('.editor--block__container')?.remove()

		const blockList = document.querySelectorAll('.editor--block__container')

		if (blockList.length < 1) {
			await createBlockEvent()
			const { selector } = storeToRefs(useEditorStore())
			if (selector.value) {
				selector.value.focus()
			}
		}
	} else {
		fileLength.innerHTML = fileListLength
	}
}

export const allDeleteFile = async (e: any) => {
	const { socket } = storeToRefs(useCommonStore())
	const { isWrite, noteUid, noteType } = storeToRefs(useEditorStore())
	if (!isWrite.value) return
	const { target } = e
	const fileUid = deletePrefix(target.closest('.editor--block').id)
	if (noteType.value === 'Project') {
		socket.value.deleteNoteBlock(noteUid.value, fileUid)
	}
	target.closest('.editor--block__container')?.remove()

	const blockList = document.querySelectorAll('.editor--block__container')

	if (blockList.length < 1) {
		await createBlockEvent()
		const { selector } = storeToRefs(useEditorStore())
		if (selector.value) {
			selector.value.focus()
		}
	}
}
